module.exports = __webpack_public_path__ + "static/media/policies.9b69288d.svg";